export const HomeHeroArt = () => (
  <svg
    className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-screen h-full md:left-0 md:translate-x-0 md:w-full pointer-events-none -z-10"
    viewBox="0 0 800 200"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
  >
    <defs>
      <radialGradient id="hero-aurora-a" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="hsl(160 75% 50%)" stopOpacity="0.08" />
        <stop offset="100%" stopColor="hsl(160 75% 50%)" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="hero-aurora-b" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="hsl(190 80% 55%)" stopOpacity="0.04" />
        <stop offset="100%" stopColor="hsl(190 80% 55%)" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="hero-aurora-c" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="hsl(135 70% 45%)" stopOpacity="0.07" />
        <stop offset="100%" stopColor="hsl(135 70% 45%)" stopOpacity="0" />
      </radialGradient>
      <filter id="hero-aurora-blur" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur stdDeviation="22" />
      </filter>
    </defs>

    <g filter="url(#hero-aurora-blur)">
      <circle cx="220" cy="110" r="150" fill="url(#hero-aurora-a)">
        <animate
          attributeName="cx"
          values="220;340;260;220"
          dur="22s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cy"
          values="110;70;130;110"
          dur="26s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="600" cy="80" r="170" fill="url(#hero-aurora-b)">
        <animate
          attributeName="cx"
          values="600;480;640;600"
          dur="28s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cy"
          values="80;130;60;80"
          dur="24s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="400" cy="160" r="130" fill="url(#hero-aurora-c)">
        <animate
          attributeName="cx"
          values="400;360;460;400"
          dur="32s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cy"
          values="160;40;130;160"
          dur="30s"
          repeatCount="indefinite"
        />
      </circle>
    </g>

    <g className="text-primary" fill="currentColor" fillOpacity="0.28">
      {Array.from({ length: 70 }).map((_, i) => {
        const x = (i * 137) % 800
        const y = (i * 53) % 200
        const r = i % 4 === 0 ? 0.9 : 0.5
        return <circle key={i} cx={x} cy={y} r={r} />
      })}
    </g>
  </svg>
)
